import { render, staticRenderFns } from "./loanProcessingDetails.vue?vue&type=template&id=f08245c4&scoped=true&"
import script from "./loanProcessingDetails.vue?vue&type=script&lang=js&"
export * from "./loanProcessingDetails.vue?vue&type=script&lang=js&"
import style0 from "./loanProcessingDetails.vue?vue&type=style&index=0&id=f08245c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08245c4",
  null
  
)

export default component.exports